import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { useI18n as a } from "next-localization";
import { D as r } from "./divider.C0gR8ZZB.js";
const l = ({
  word: o,
  dividerWrapperClassName: n = "d-flex justify-content-center align-items-center gap-1 neu-text-tag",
  ...t
}) => {
  const { t: i } = a(), s = i("Common.Or");
  return /* @__PURE__ */ m("div", { className: n, children: [
    /* @__PURE__ */ e(r, { ...t }),
    o ?? s,
    /* @__PURE__ */ e(r, { ...t })
  ] });
};
export {
  l as W
};
